export const CREATED_WATCHING = "CREATED_WATCHING";
export const DELETED_WATCHING = "CHANGED_WATCHING";
export const RECEIVED_WATCHING = "RECEIVED_WATCHING";
export const FETCHED_WATCHING = "FETCHED_WATCHING";
